import * as React from 'react';

function SvgIconMarketing(props) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.453 12.968l6.755-6.757a.141.141 0 00.041-.112L13.794.715a.286.286 0 00-.26-.26L8.148 0a.139.139 0 00-.112.04L1.282 6.798a.143.143 0 000 .202l5.969 5.97a.14.14 0 00.202 0zm2.192-9.527a.86.86 0 011.212 0 .86.86 0 010 1.213.86.86 0 01-1.212 0 .86.86 0 010-1.213zm5.069 5.053l-.707-.706a.143.143 0 00-.202 0l-6.466 6.454-4.244-4.233a.144.144 0 00-.202 0l-.708.705a.143.143 0 000 .202l4.344 4.337.708.706a.144.144 0 00.202 0l7.275-7.263a.143.143 0 000-.202z" />
    </svg>
  );
}

export default SvgIconMarketing;
